<template>
  <v-app>
    <MsgSnackbar />
    <NavigationLoggedIn LoggedIn v-if="isLoggedIn" />
    <navigation-drawer-overlay v-if="showNavigationOverlay && !useMobileMenu" />
    <notifications-list />
      <v-main >
        <div class="maintenance-banner" v-if="isLoggedIn && maintenanceBannerText">
          <v-icon style="padding-right: 8px">$maintenance</v-icon>
          <rich-text class="my-auto" :markdown-text="maintenanceBannerText"/>
        </div>
        <router-view v-if="showMainView" style="max-width: 1500px" :class="routeName !== 'login' ? 'mx-auto' : ''" />
        <LoadingSpinner v-else />
        <portal-update-dialog />
      </v-main>
    <the-footer v-if="isLoggedIn"></the-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import MsgSnackbar from "@/components/ui/MsgSnackbar.vue";
import NavigationLoggedIn from "./components/navigation/private/NavigationLoggedIn.vue";
import TheFooter from "@/components/layout/TheFooter.vue";
import LoadingSpinner from "@/components/layout/LoadingSpinner";
import NotificationsList from "@/components/lists/NotificationsList.vue";
import RichText from "@/components/ui/RichText.vue";
import NavigationDrawerOverlay from "@/components/navigation/private/NavigationDrawerOverlay.vue";
import {useMobileMenu} from "@/mixins/useMobileMenu";
import PortalUpdateDialog from "@/components/ui/PortalUpdateDialog.vue";

export default {
  name: "App",
  components: {
    PortalUpdateDialog,
    NavigationDrawerOverlay,
    RichText,
    NotificationsList,
    MsgSnackbar,
    NavigationLoggedIn,
    TheFooter,
    LoadingSpinner
  },
  data: () => ({
    showNewsletterSignUp: false,
  }),
  mixins: [useMobileMenu],
  watch: {
    userId(newUserId) {
      if (!newUserId) return;

      const mail = this.userEmail;

      sessionStorage.user_mail = mail;
      sessionStorage.user_id = newUserId.toString();
    },
  },
  computed: {
    ...mapGetters({
      userEmail: "user/userEmail",
      userId: "user/userId"
    }),
    ...mapGetters("user", ["maintenanceBannerText"]),
    ...mapGetters("navigation", ["showNavigationOverlay"]),
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    routeName() {
      return this.$route.name
    },
    showMainView() {
      const PUBLIC_ROUTES = ["login", "oauth-redirect"];
      const CURR_ROUTE = String(this.$route.name).toLowerCase();
      return this.isLoggedIn || PUBLIC_ROUTES.indexOf(CURR_ROUTE) != -1;
    }
  }
};
</script>

<style>
@import "./styles/app.css";

.maintenance-banner {
  position: sticky;
  top: 64px;
  z-index: 2;
  padding: 8px 16px;
  background: #FDD835;
  font-size: 14px;
  line-height: 20px;
  font-family: "GeometriaGeometria", sans-serif;
  color: #1F2B37;
  display: flex;
  flex-direction: row;
}

@media (max-width: 959px) {
  .maintenance-banner {
    top: 56px;
  }
}

.maintenance-banner p {
  margin-bottom: unset !important;
}
</style>
